import { useI18n } from "@wordpress/react-i18n";
import React from "react";
export function ForminatorCurrency(props) {
    const { __ } = useI18n();
    const { id, value, onChange, limit_min, limit_max, limit_min_message, limit_max_message, setErrors, currency, } = props;
    const min = parseFloat(limit_min);
    const max = parseFloat(limit_max);
    return React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        React.createElement("input", { type: "number", className: 'ltg-control', onChange: ({ target }) => {
                let valueStr = target.value.replace(',', '.');
                valueStr = valueStr.replace(/[^0-9.,]/g, '');
                const value = parseFloat(valueStr);
                onChange(valueStr);
                if (value < min)
                    setErrors((prev) => (Object.assign(Object.assign({}, prev), { [id]: limit_min_message || __('Įveskite skaičių didesnį už') + ` ${min}` })));
                if (value > max)
                    setErrors((prev) => (Object.assign(Object.assign({}, prev), { [id]: limit_max_message || __('Įveskite skaičių mažesnį už') + ` ${max}` })));
            }, value: value || '' }),
        React.createElement("div", { style: { marginBottom: 10, marginLeft: 10 } }, currency));
}
